import {
  Comment,
  computed,
  Text,
  useSlots,
  type ComputedRef,
  type Slots,
  type VNode,
} from 'vue'

/**
 * 检测指定插槽是否包含有效内容
 * @param slotName - 要检测的插槽名称
 * @returns 返回一个计算属性，表示插槽是否有内容
 */
export function useSlotHasContent(slotName: string): ComputedRef<boolean> {
  const slots = useSlots() as Slots

  return computed<boolean>(() => {
    const slotContent = slots[slotName]?.()

    // 如果插槽不存在或内容为空数组，返回false
    if (!slotContent || slotContent.length === 0) {
      return false
    }

    // 遍历所有VNode节点
    return slotContent.some((vnode: VNode) => {
      // 忽略注释节点
      if (vnode.type === Comment) {
        return false
      }

      // 处理文本节点 - 检查是否包含非空白内容
      if (vnode.type === Text) {
        const children = vnode.children
        return typeof children === 'string' && children.trim() !== ''
      }

      // 其他类型的节点（元素、组件等）都视为有效内容
      return true
    })
  })
}
